import { Message, MessageRole, Messages, MessageType } from "@/models/Message";
import endpoints from "./messages.endpoint";
import { MessageRequest, MessageResponse } from "./messages.type";

import { useAPIMutation } from "../useAPI";

export const useSendMessage = (threadId: string) =>
  useAPIMutation<
    MessageRequest,
    MessageResponse,
    Message,
    Messages
  >(
    "POST",
    endpoints.POST_THREAD_MESSAGE(threadId),
    modelToRequest,
    responseToModel,
  );

const modelToRequest = (model: Message): MessageRequest => {
  return {
    id: model.id,
    threadId: model.threadId,
    role: model.role,
    type: model.type,
    sender: model.sender,
    recipient: model.recipient,
    content: model.content,
    createdAt: model.createdAt.toISOString(),
  };
};
const responseToModel = (response: MessageResponse): Messages => {
  const items = response.messages.map((item) => {
    return new Message({
      id: item.id,
      threadId: item.threadId,
      role: item.role as MessageRole,
      type: item.type as MessageType,
      senderIcon: undefined,
      sender: item.sender,
      recipient: "",
      content: item.content,
      createdAt: new Date(item.createdAt),
    });
  });
  return new Messages(items);
};
